import { DeleteOutline } from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import React from 'react';

interface ControlToolbarProps {
  handleDelete: () => void;
  isDisabled: boolean;
  handleUndo: () => void;
  handleRedo: () => void;
}

const ControlToolbar: React.FC<ControlToolbarProps> = ({
  handleDelete,
  isDisabled,
  handleUndo,
  handleRedo,
}) => {
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: '1.5rem',
        }}
      >
        <Button
          disableRipple
          disableFocusRipple
          disableTouchRipple
          variant="outlined"
          sx={{
            color: '#FF6347',
            textTransform: 'none',
            fontSize: '0.874rem',
            lineHeight: '20px',
            fontWeight: 700,
            border: '1px solid #FF6347',
            borderRadius: '0.5rem',
            '&:hover': {
              border: '1px solid #FF6347',
              backgroundColor: 'rgba(255, 99, 71, 0.08)', // subtle tint on hover
            },
          }}
          startIcon={<DeleteOutline />}
          onClick={handleDelete}
          disabled={isDisabled}
        >
          Delete
        </Button>
        <Box sx={{ backgroundColor: '#fff', borderRadius: '0.5rem' }}>
          <Button
            disableRipple
            disableFocusRipple
            disableTouchRipple
            variant="outlined"
            sx={{
              color: '#162936',
              textTransform: 'none',
              fontSize: '0.874rem',
              lineHeight: '20px',
              fontWeight: 700,
              border: '1px solid #D8DBDD',
              borderRadius: '0.5rem 0 0 0.5rem',
              '&:hover': {
                border: '1px solid #D8DBDD',
              },
            }}
            onClick={handleUndo}
          >
            Undo
          </Button>
          <Button
            disableRipple
            disableFocusRipple
            disableTouchRipple
            variant="outlined"
            sx={{
              color: '#162936',
              textTransform: 'none',
              fontSize: '0.874rem',
              lineHeight: '20px',
              fontWeight: 700,
              border: '1px solid #D8DBDD',
              borderRadius: ' 0 0.5rem  0.5rem 0',

              '&:hover': {
                border: '1px solid #D8DBDD',
              },
            }}
            onClick={handleRedo}
          >
            Redo
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default ControlToolbar;
